module.exports = __webpack_public_path__ + "./images/p24.JPG?0de237938e088073fa9bd5981154a838";


//////////////////
// WEBPACK FOOTER
// ./src/products/p24.JPG
// module id = 60
// module chunks = 0